import RelatedEvents from 'components/Section/RelatedEvents'

export default function FeaturedEvents({ section }) {
  if (!section || section.events.length === 0) return null

  return <RelatedEvents section={{ ...section }} />
}
